import { Form, Input } from "antd";
import { useEffect } from "react";
import * as Validation from "../../../../../utils/helper/validation";
import * as Apis from "../../../../../utils/helper/enum";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const DriverBankDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    if (values?.errorFields?.length > 0) return;

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_DRIVERS?.CREATE_DRIVERS;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_DRIVERS?.EDIT_DRIVERS + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Driver created successfully";
        if (id) msg = "Driver updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-driver");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getDriverDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_DRIVERS.GET_DRIVERS_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue(
          "benificiory_name",
          data?.driverPayoutDetail
            ? data?.driverPayoutDetail?.beneficiaryName
            : ""
        );
        form.setFieldValue(
          "account_number",
          data?.driverPayoutDetail
            ? data?.driverPayoutDetail?.accountNumber
            : ""
        );
        form.setFieldValue(
          "iban_number",
          data?.driverPayoutDetail ? data?.driverPayoutDetail?.IBAN : ""
        );
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getDriverDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          onFinishFailed={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Benificiory Name"
            name="benificiory_name"
            rules={[
              {
                required: true,
                message: "Please enter your benificiory name.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("first_name", value.trimStart());
                handleInputChange("first_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Account Number"
            name="account_number"
            rules={[
              {
                required: true,
                message: "Please enter your account number.",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("account_number", value.trimStart());
                handleInputChange("account_number");
              }}
            />
          </Form.Item>
          <Form.Item
            label="IBAN Number"
            name="iban_number"
            rules={[
              {
                required: true,
                message: "Please enter your iban number",
              },
              {
                max: 50,
                message: "Maximum 50 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={true}
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("iban_number", value.trimStart());
                handleInputChange("iban_number");
              }}
            />
          </Form.Item>
        </Form>
        <div className="flex justify-end gap-3">
          {/* <Button onClick={() => navigate("/manage-driver")}>Cancel</Button> */}
          {/* <Button
              type="primary"
              htmlType="submit"
              onClick={() => form.submit()}
            >
              Save
            </Button> */}
        </div>
      </div>
    </>
  );
};
export default DriverBankDetail;
